import Model from 'flarum/common/Model';
/**
 * Frontend model for the `waterfall-images` JSON:API resource.
 */
export default class WaterfallImage extends Model {
  src() {
    return Model.attribute('src').call(this);
  }
  thumb() {
    return Model.attribute('thumb').call(this);
  }
  title() {
    return Model.attribute('title').call(this);
  }
  likesCount() {
    return Model.attribute('likesCount', value => value ?? 0).call(this);
  }
  viewsCount() {
    return Model.attribute('viewsCount', value => value ?? 0).call(this);
  }
  score() {
    return Model.attribute('score', value => value ?? 0).call(this);
  }
  status() {
    return Model.attribute('status', value => value ?? 'pending').call(this);
  }
  error() {
    return Model.attribute('error').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  canLike() {
    return Model.attribute('canLike').call(this);
  }
  canDelete() {
    return Model.attribute('canDelete').call(this);
  }
  isLiked() {
    return Model.attribute('isLiked', value => !!value).call(this);
  }
  user() {
    return Model.hasOne('user').call(this);
  }
  likes() {
    return Model.hasMany('likes').call(this);
  }

  /**
   * The effective image to render in the grid (thumb falls back to src).
   */
  displaySrc() {
    return this.thumb() || this.src();
  }
}
flarum.reg.add('lcoy-waterfall', 'common/models/WaterfallImage', WaterfallImage);